import { dispatchSearchClickEvent, ESearchType, SEARCH_CLICK_EVENT } from 'browser/utils';
import { selectSearchQuery } from 'shared/selectors';
import { TReduxStore } from 'shared/types/redux';

export function handleClickSearchSuggestion(store: TReduxStore, data: { type: ESearchType }) {
  const searchQuery = selectSearchQuery(store.getState());

  if (!searchQuery || searchQuery.trim() === '') {
    return {
      success: false,
      error: 'Query string is empty',
    };
  }

  dispatchSearchClickEvent({ type: data.type });

  return {
    success: true,
    dispatchedEvent: SEARCH_CLICK_EVENT,
    eventDetail: { type: data.type },
  };
}
